import { BreachEvent, click_origin_breach_screen } from '@news-mono/web-common'
import React from 'react'
import { useAuthActions } from '../../../../../authentication/AuthenticationProvider'
import { SubscriptionPackages } from '../../../../common'
import { createLinkClickEvent } from '../../../../createLinkClickHandler'
import SubscriptionPackage from '../../../SubscriptionPackage/SubscriptionPackage'
import { WestRewardsMessage } from '../../shared-components/WestRewardsMessage/WestRewardsMessage'
import {
    StyledBreachWallContent,
    StyledButton,
    StyledHelpMessage,
    StyledPackage,
    StyledRegistrationInfo,
    StyledTextLink,
} from './BreachWallContent.styled'

export interface BreachWallContentProps {
    title: () => JSX.Element | null
    terms: () => JSX.Element | null
    mediaBanner: () => JSX.Element | null
    subscriptionPackages?: SubscriptionPackages

    breachCreativeName: string
    breachDeal: string

    onEvent: (event: BreachEvent) => void
}

export const BreachWallContent: React.FC<BreachWallContentProps> = ({
    title,
    subscriptionPackages,
    breachCreativeName,
    breachDeal,
    onEvent,
    mediaBanner,
    terms,
}) => {
    const renderMediaBanner = mediaBanner
    const renderTitleSection = title
    const renderTerms = terms
    const { onSubscribeClick } = useAuthActions()

    return (
        <StyledBreachWallContent>
            {renderMediaBanner()}
            <StyledRegistrationInfo>
                {renderTitleSection()}
            </StyledRegistrationInfo>
            <StyledPackage>
                {subscriptionPackages &&
                    subscriptionPackages.map(
                        (subscriptionPackageItem, index) => {
                            return (
                                <SubscriptionPackage
                                    key={index}
                                    breachCreativeName={breachCreativeName}
                                    breachDeal={breachDeal}
                                    onEvent={onEvent}
                                    ribbonTitle={
                                        subscriptionPackageItem.ribbonTitle
                                    }
                                    pretitle={subscriptionPackageItem.pretitle}
                                    heading={subscriptionPackageItem.heading}
                                    price={subscriptionPackageItem.price}
                                    originalPrice={
                                        subscriptionPackageItem.originalPrice
                                    }
                                    priceQualifier={
                                        subscriptionPackageItem.priceQualifier
                                    }
                                    offerCode={
                                        subscriptionPackageItem.offerCode
                                    }
                                    packageTheme={
                                        subscriptionPackageItem.packageTheme
                                    }
                                    packagePath={
                                        subscriptionPackageItem.packagePath
                                    }
                                    packageType={
                                        subscriptionPackageItem.packageType
                                    }
                                    cancellationMessage={
                                        subscriptionPackageItem.cancellationMessage
                                    }
                                    googleSKU={
                                        subscriptionPackageItem.googleSKU
                                    }
                                />
                            )
                        },
                    )}
            </StyledPackage>
            <StyledButton
                onClick={() => {
                    createLinkClickEvent(
                        breachCreativeName,
                        breachDeal,
                        onEvent,
                    )()
                    onSubscribeClick({
                        callToAction: click_origin_breach_screen,
                    })
                }}
            >
                View All Packages
            </StyledButton>
            <StyledHelpMessage>
                Need Help? Call us at{' '}
                <StyledTextLink reverseColor={true} href="tel:1800 811 855">
                    1800 811 855
                </StyledTextLink>
            </StyledHelpMessage>
            <WestRewardsMessage />
            {renderTerms()}
        </StyledBreachWallContent>
    )
}
BreachWallContent.displayName = 'BreachWallContent'

export default BreachWallContent
